import React from 'react';
import { Link } from 'react-router-dom';

/** Fallback-Seite für unbekannte Routen. */
export default function NotFoundPage() {
  return (
    <section className="flex flex-col items-center justify-center py-24 text-center">
      <p className="text-6xl">🤷</p>
      <h1 className="mt-4 font-serif text-3xl font-semibold text-ink">Seite nicht gefunden</h1>
      <p className="mt-2 text-ink-muted">
        Diese Seite existiert nicht (mehr).
      </p>
      <Link
        to="/"
        className="mt-6 rounded-lg bg-ink px-4 py-2 font-medium text-paper transition-colors hover:bg-ink-soft"
      >
        Zur Übersicht
      </Link>
    </section>
  );
}
